/**
 * This file is part of Full Page Carousel.
 *
 * Full Page Carousel is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Full Page Carousel is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Full Page Carousel.  If not, see <https://www.gnu.org/licenses/>.
 */
import fullpage from 'fullpage.js/dist/fullpage';

import 'fullpage.js/dist/fullpage.css';
import './view.scss';

document.querySelectorAll( '.wp-block-tandem-full-page-carousel' ).forEach( ( el ) => {
	const sectionSelector = '.wp-block-tandem-full-page-slide';

	// Must be done before the limit, to allow for “a single random image” trick.
	if ( el.dataset.shuffleSlides ) {
		const slides = Array.from( el.querySelectorAll( sectionSelector ) );
		while ( slides.length > 0 ) {
			const randomIndex = Math.floor( Math.random() * slides.length );
			el.insertAdjacentElement( 'beforeend', slides[randomIndex] );
			slides.splice( randomIndex, 1 );
		}
	}

	if ( el.dataset.slidesLimit ) {
		const slidesLimit = Math.max( 1, parseInt( el.dataset.slidesLimit, 10 ) );
		const slides = Array.from( el.querySelectorAll( sectionSelector ) );
		for ( let i = slidesLimit; i < slides.length; i++ ) {
			slides[i].remove();
		}
	}

	const options = Object.assign( JSON.parse( el.dataset.options || '{}' ), {
		licenseKey: 'gplv3-license',
		sectionSelector,
		credits: false,
		scrollOverflowMacStyle: true,
		afterLoad( origin, destination ) {
			const originBodyClass = origin.item.dataset.bodyClass;
			originBodyClass && document.body.classList.remove( originBodyClass );
			const destinationBodyClass = destination.item.dataset.bodyClass;
			destinationBodyClass && document.body.classList.add( destinationBodyClass );
		}
	} );

	if ( options.autoplay ) {
		options.loopBottom = ! options.continuousVertical;
		const autoplaySpeed = options.autoplaySpeed ?? 5000;

		let timeout;
		const prevAfterLoad = options.afterLoad;
		options.afterLoad = function ( ...args ) {
			prevAfterLoad( ...args );
			timeout = setTimeout( fullpage_api.moveSectionDown, autoplaySpeed );
		};
		options.onLeave = function () {
			clearTimeout( timeout );
		};
	}

	// noinspection JSPotentiallyInvalidConstructorUsage
	new fullpage( el, options );

	function moveText( e ) {
		el.style.setProperty( '--text-x', e.offsetX + 'px' );
		el.style.setProperty( '--text-y', e.offsetY + 'px' );
	}

	el.style.setProperty( '--text-x', '50%' );
	el.style.setProperty( '--text-y', '50%' );
	el.addEventListener( 'mouseover', moveText );
	el.addEventListener( 'mousemove', moveText );
} )
